import { FONT_SIZES } from '@/enums/theme'

export const MenuHeight = 90
export const TopbarHeight = 85
// DO-13065: amber "verify your e-mail" bar above the desktop header. While it is shown MenuV2 publishes
// `--header-height` (MenuHeight + bar) on <html> for the sass layout grid, and AppThemeProvider bumps
// theme.menuHeight / pageContentOffset by the same amount for every `calc(100vh - menuHeight)` page.
export const EmailConfirmationBarHeight = 32
export const HEADER_HEIGHT_CSS_VAR = '--header-height'
const INPUT_SPECS = Object.freeze({
  inputDefault: {
    color: '#333333',
    borderColor: '#dee2ed',
    borderRadius: '5px',
    backgroundColor: '#f6f7fa',
  },
})

export default {
  // headline
  pageHeadline: {
    fontSize: FONT_SIZES.xlarge,
  },
  userSettings: {
    h1: {
      fontSize: FONT_SIZES.xlarge,
    },
    h2: {
      fontSize: FONT_SIZES.medium,
    },
  },
  Panel: {
    header: {
      controls: {
        color: '#aaa',
      },
    },
  },
  DocumentControlButton: {
    iconColor: '#757b8a',
  },
  Input: {
    borderColor: '#7599e9',
  },
  primaryColors: {
    custom1: '#1B4EBE',
    custom2: '#2350dd',
  },
  ToolbarButton: {
    backgroundColor: INPUT_SPECS.inputDefault.backgroundColor,
    borderColor: INPUT_SPECS.inputDefault.borderColor,
    color: INPUT_SPECS.inputDefault.color,
    borderRadius: INPUT_SPECS.inputDefault.borderRadius,
  },
  mixins: {
    truncateText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    formRow: (margin) => ({
      display: 'flex',
      marginBottom: margin || '2.5rem',
    }),
    formRowColumn: (padding) => ({
      flex: '1 1 50%',
      '&:last-of-type': {
        paddingLeft: padding || '1rem',
      },
      '&:first-of-type, &:only-child': {
        paddingRight: padding || '1rem',
        paddingLeft: 0,
      },
    }),
    rowColumn: (margin) => ({
      flex: '1 1 50%',
      '&:last-of-type': {
        marginLeft: margin || '1rem',
      },
      '&:first-of-type, &:only-child': {
        marginRight: margin || '1rem',
        marginLeft: 0,
      },
    }),
  },
  zIndexes: {
    bankingMinimizeButton: 99,
    offlineScreen: 20000,
    advancedDatePicker: 990,
    loader: 20,
    loaderInline: 10,
    // Above MUI's `zIndex.modal` (1300): a menu portalled to document.body has to paint over the
    // dialog it escaped from.
    selectMenuPortal: 1400,
    // The dashboard's floating controls only have to clear the widgets. They stay
    // below the page topbar (9), the drawers opened from the menu (100), the menu
    // itself and every modal.
    dashboardEditButton: 5,
    dashboardEditBar: 90,
  },

  menuHeight: MenuHeight,
  pageContentOffset: MenuHeight + TopbarHeight,

  // notification
  notification: {
    drawer: {
      offsetTop: MenuHeight,
      background: '#f6f7fa',
    },
  },

  // search
  search: {
    drawer: {
      offsetTop: MenuHeight,
      background: '#f6f7fa',
    },
  },
}
